import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

export default function OdemeBekleme() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');

  return (
    <section className="py-5">
      <div className="container text-center">
        <h2 className="mb-3">Ödeme Beklemede</h2>
        <p className="text-warning mb-2">
          Ödemeniz işleniyor. Lütfen bu sayfayı kapatmayın.
        </p>
        {orderId && <p className="small text-muted">Sipariş no: {orderId}</p>}
        <p className="mt-3">
          İşleminiz kısa süre içinde tamamlanacaktır. Herhangi bir sorun olursa
          sipariş numaranızı saklayarak bizimle iletişime geçebilirsiniz.
        </p>
        <Link to="/" className="btn btn-primary mt-3">Ana Sayfaya Dön</Link>
      </div>
    </section>
  );
}
